<template>
<div>
  <el-select v-show="selectedManagetypeId === null" class="mr-r4" v-model="managetypeId" style="width: 120px;">
    <el-option v-for="item in managetypeList" :key="item.managetypeId" :label="item.managetypeName" :value="item.managetypeId"></el-option>
  </el-select>
  <el-select class="mr-r4" v-show="((managetypeId === 'NMS' &&  showInterfaceFilter) || managetypeId === 'VMS') && !isRootCause" v-model="managetypeKey" style="width:142px;">
    <el-option v-for="item in managetypeKeyList" :key="item.managetypeKey" :label="item.managetypeKeyName" :value="item.managetypeKey"></el-option>
  </el-select>
  <el-select v-show="managetypeId === 'NMS'" v-model="objCompanyId" style="width:120px;" placeholder="제조사" clearable>
    <el-option v-for="item in objCompanyList" :key="item.objCompanyId" :label="item.objCompanyName" :value="item.objCompanyId"></el-option>
  </el-select>
  <el-select v-show="managetypeId !== 'NMS' && managetypeId !== 'SVC' && managetypeId !== 'E2E' && managetypeId !== 'VMS'" v-model="objtypeId" style="width:120px;" placeholder="장비 종류" clearable>
    <el-option v-for="item in objtypeList" :key="item.objtypeId" :label="item.objtypeName" :value="item.objtypeId"></el-option>
  </el-select>
  <el-select v-show="managetypeId == 'VMS'" v-model="hypervisorType" style="width:142px;" placeholder="하이퍼바이저 종류" clearable>
    <el-option v-for="item in hypervisorTypeList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
  </el-select>
</div>
</template>

<script>
import { isEqual, isEmpty, isNil, filter, slice } from 'lodash';
import managetypeKeyApi from '@/api/model/managetype-key';
import BasicinfoSubAPI from '@/api/model/basicinfo-sub';
import logicalGroupApi from '@/api/settings/common/logical-group';
import { physicalObjTableColumns } from '@/constants/table';

/**
 * 장비 타입 필터 컴포넌트
 */
export default {
  name: 'WObjTypeFilter',
  props: {
    selectedManagetypeId: {
      type: String,
      default: null,
    },
    managetypeData: {
      type: Array,
    },
    showInterfaceFilter: {
      type: Boolean,
      default: false,
    },
    /**
     * 최초 컴포넌트 생성 시점에 관리 구분 로드 여부 (mounted hook)
     */
    initLoad: {
      type: Boolean,
      default: false,
    },
    /**
     * 장비 구분에 맞는 컬럼 반환 시 selection 컬럼 포함 여부
     */
    includeSelection: {
      type: Boolean,
      default: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    // 제외할 objDefineId들을 배열로 정의한다
    exceptDefineIds: {
      type: Array,
    },
    // 제외할 objtypeId들을 배열로 정의한다.
    exceptObjtypeIds: {
      type: Array,
    },
    // 필터링할 objDefineId들을 배열로 정의한다.
    objDefineIds: {
      type: Array,
    },
    // 필터링할 objtypeId들을 배열로 정의한다.
    objtypeIds: {
      type: Array,
    },
    // 네트워크 장비를 부모로 가지는 관리 대상 숨김 여부
    hiddenNetdeviceChildren: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isRootCause: false, // 장비 연관 관계 화면에서 사용 판단 여부
      managetypeList: [],
      managetypeId: null,
      managetypeKeyList: [],
      managetypeKey: null,
      objCompanyList: null,
      objCompanyId: null,
      objtypeList: null,
      objtypeId: null,
      hypervisorTypeList: null,
      hypervisorType: null,
      /**
       * 장비 타입별 컬럼 정보 객체
       * @type {Objec5}
       */
      physicalObjTableColumns,
      /**
       * 설정한 장비 타입에 해당하는 컬럼 배열
       * @type {Array}
       */
      columns: [],
      /**
       * 설정한 장비 타입 정보 객체
       * @type {Object}
       */
      params: null,
    };
  },
  watch: {
    managetypeData: {
      handler() {
        this.loadManagetype();
      },
    },
    params: {
      handler(to) {
        if (!isEmpty(to)) {
          this.onFilterChange();
          //   if (isEmpty(from) || to.managetypeId !== from.managetypeId || to.managetypeKey !== from.managetypeKey) {
          //     // TODO columns를 변경하더라도 label이 변경되지 않는 문제있어 빈 columns을 먼저 주고 관리 구분에 맞는 컬럼을 설정하도록 함.
          //     // v-for에서 재사용으로 인한 문제로 파악되며 근본적인 해결책을 찾을 경우 해당 로직 수정 필요
          //     this.columns = [];
          //     this.$refs.objTable.clearFilter();
          //     this.$nextTick(() => {
          //       this.columns = this.getColumns();
          //     });
          //   }
          //   this.loadData();
        }
      },
    },
    managetypeId(to) {
      if (to === null) {
        return;
      }

      if (to === 'NMS' || to === 'VMS') {
        this.loadManagetypeKey(to);
      } else {
        this.managetypeKeyList = null;
        this.managetypeKey = null;
        this.loadObjtype(to);
        this.params = {
          managetypeId: to,
          objtypeId: null,
        };
      }
    },
    managetypeKey(to) {
      if (to === null) {
        return;
      }

      if (this.managetypeId === 'NMS') {
        this.loadCompany(this.managetypeId);
        this.params = {
          managetypeId: this.managetypeId,
          managetypeKey: to,
          objCompanyId: null,
        };
      } else if (this.managetypeId === 'VMS') {
        this.loadHypervisorType(this.managetypeId);
        this.params = {
          managetypeId: this.managetypeId,
          managetypeKey: to,
          hypervisorType: null,
        };
      }
    },
    /**
     * 벤더 변경
     * @author Ju
     * @param  {[type]} to [description]
     * @return {[type]}    [description]
     */
    objCompanyId(to) {
      if (to === null) {
        return;
      }

      let objCompanyId;
      if (to === '') {
        objCompanyId = null;
      } else {
        objCompanyId = to;
      }

      this.params = {
        managetypeId: this.managetypeId,
        managetypeKey: this.managetypeKey,
        objCompanyId,
      };
    },
    /**
     * 장비 종류 변경
     * @author Ju
     * @param  {[type]} to [description]
     * @return {[type]}    [description]
     */
    objtypeId(to) {
      if (to === null) {
        return;
      }

      let objtypeId;
      if (to === '') {
        objtypeId = null;
      } else {
        objtypeId = to;
      }

      this.params = {
        managetypeId: this.managetypeId,
        objtypeId,
      };
    },
    hypervisorType(to) {
      if (to === null) {
        return;
      }

      let hypervisorType;
      if (to === '') {
        hypervisorType = null;
      } else {
        hypervisorType = to;
      }

      this.params = {
        managetypeId: this.managetypeId,
        managetypeKey: this.managetypeKey,
        hypervisorType,
      };
    },
    active(to) {
      if (!to) {
        this.objCompanyId = '';
        this.objtypeId = '';
        this.hypervisorType = '';
      }
    },
  },
  mounted() {
    if (this.initLoad) {
      this.loadManagetype();
    }
  },
  methods: {
    /**
     * 관리 구분 정보를 로드한다.
     */
    loadManagetype() {
      const managetypeList = isEmpty(this.managetypeData) ? this.$store.getters.activeManagetypesToShow : this.managetypeData;
      if (isEmpty(managetypeList)) {
        this.loadManagetype();
      } else {
        this.managetypeList = managetypeList;
        if (!isNil(this.selectedManagetypeId)) {
          this.managetypeId = this.selectedManagetypeId;
        } else {
          this.managetypeId = this.managetypeList[0].managetypeId;
        }
      }
    },
    /**
     * 관리 구분 키 정보를 로드한다.
     * @param  {String} managetypeId 관리 구분 아이디
     */
    loadManagetypeKey(managetypeId) {
      managetypeKeyApi
        .getDisplayedManagetypeKeyList(managetypeId)
        .then((response) => {
          if (!isEmpty(response.data) && response.data.success === true && !isEmpty(response.data.data)) {
            if (isEqual(managetypeId, 'VMS')) {
              this.managetypeKeyList = filter(response.data.data, (item) => item.managetypeKey !== '_');
            } else {
              this.managetypeKeyList = response.data.data;
            }
            this.managetypeKey = this.managetypeKeyList[0].managetypeKey;
          } else {
            this.managetypeKeyList = null;
            this.managetypeKey = null;
          }
        })
        .catch(() => {
          this.managetypeKeyList = null;
          this.managetypeKey = null;
        });
    },
    /**
     * 벤더 정보를 로드한다.
     * @author Ju
     * @param  {String} managetypeId 관리 구분 아이디
     */
    loadCompany(managetypeId) {
      const params = { managetypeId };
      if (!isEmpty(this.exceptDefineIds)) {
        params.exceptDefineIds = this.exceptDefineIds;
      }
      if (!isEmpty(this.exceptObjtypeIds)) {
        params.exceptObjtypeIds = this.exceptObjtypeIds;
      }
      if (!isEmpty(this.objDefineIds)) {
        params.objDefineIds = this.objDefineIds;
      }
      if (!isEmpty(this.objtypeIds)) {
        params.objtypeIds = this.objtypeIds;
      }
      if (this.hiddenNetdeviceChildren) {
        params.hiddenNetdeviceChildren = this.hiddenNetdeviceChildren;
      }
      logicalGroupApi
        .getUsingObjCompanyList(params)
        .then((response) => {
          const result = response.data;
          if (!isEmpty(result) && result.success === true && !isEmpty(result.data)) {
            this.objCompanyList = result.data;
            this.objCompanyId = null;
          } else {
            this.objCompanyList = null;
            this.objCompanyId = null;
          }
        })
        .catch(() => {
          this.objCompanyList = null;
          this.objCompanyId = null;
        });
    },
    /**
     * 장비 구분 정보를 로드한다.
     * @param  {String} managetypeId 관리 구분 아이디
     */
    loadObjtype(managetypeId) {
      logicalGroupApi
        .getUsingObjtypeList(managetypeId)
        .then((response) => {
          const result = response.data;
          if (!isEmpty(result) && result.success === true && !isEmpty(result.data)) {
            this.objtypeList = result.data;
            this.objtypeId = null;
          } else {
            this.objtypeList = null;
            this.objtypeId = null;
          }
        })
        .catch(() => {
          this.objtypeList = null;
          this.objtypeId = null;
        });
    },
    /**
     * 하이퍼바이저 타입 정보를 로드한다.
     */
    loadHypervisorType() {
      BasicinfoSubAPI.getList('HYPERVISOR_TYPE')
        .then((response) => {
          const result = response.data;
          if (!isEmpty(result) && result.success === true && !isEmpty(result.data)) {
            this.hypervisorTypeList = result.data;
            this.hypervisorType = null;
          } else {
            this.hypervisorTypeList = null;
            this.hypervisorType = null;
          }
        })
        .catch(() => {
          this.hypervisorTypeList = null;
          this.hypervisorType = null;
        });
    },
    /**
     * 관리 구분에 맞는 테이블 정보를 반환한다.
     * @author Ju
     * @return {[type]} [description]
     */
    getColumns() {
      let columns;
      const managetypeId = this.managetypeId;
      if (managetypeId === 'NMS') {
        if (this.managetypeKey === 'ND') {
          columns = this.physicalObjTableColumns.netdeviceColumns;
        } else {
          columns = this.physicalObjTableColumns.netinterfaceColumns;
        }
      } else if (managetypeId === 'SMS') {
        columns = this.physicalObjTableColumns.serverColumns;
      } else if (managetypeId === 'E2E') {
        columns = this.physicalObjTableColumns.e2eColumns;
      } else if (managetypeId === 'FMS') {
        columns = this.physicalObjTableColumns.sensorColumns;
      } else if (managetypeId === 'DBMS') {
        columns = this.physicalObjTableColumns.dbColumns;
      } else if (managetypeId === 'SVC') {
        columns = this.physicalObjTableColumns.serviceColumns;
      } else if (managetypeId === 'VMS') {
        if (this.managetypeKey === 'VCL') {
          columns = this.physicalObjTableColumns.hostClusterColumns;
        } else if (this.managetypeKey === 'VHO') {
          columns = this.physicalObjTableColumns.hostColumns;
        } else if (this.managetypeKey === 'VVM') {
          columns = this.physicalObjTableColumns.vmColumns;
        } else if (this.managetypeKey === 'VDSC') {
          columns = this.physicalObjTableColumns.storageClusterColumns;
        } else {
          columns = this.physicalObjTableColumns.storageColumns;
        }
      } else if (managetypeId === 'EMS') {
        columns = this.physicalObjTableColumns.emsColumns;
      } else if (managetypeId === 'APM2X') {
        columns = this.physicalObjTableColumns.wasColumns;
      } else {
        columns = [];
      }

      if (!this.includeSelection) {
        return slice(columns, 1, columns.length);
      }
      return columns;
    },
    /**
     * 필터 변경 이벤트 핸들러
     * 변경된 조건과 조건에 맞는 컬럼을 파라미터로 'filter-change' 이벤트를 emit한다.
     * @author Ju
     */
    onFilterChange() {
      this.$emit('filter-change', this.params, this.getColumns());
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/table/CheckObjTable/components/ObjTypeFilter.vue